import { useCallback, useState } from 'react'

const useTabs = <MT extends React.MouseEvent | React.TouchEvent>() => {
    const [pressed, setPressed] = useState(false)
    const [isScrolling, setIsScrolling] = useState(false)
    const [clientXStart, setClientXStart] = useState(0)
    const [scrollLeft, setScrollLeft] = useState(0)

    const getClientX = useCallback(({ nativeEvent: ne }: MT) => {
        if (ne instanceof MouseEvent) return ne.clientX
        if (ne instanceof TouchEvent) return ne.touches[0].clientX
        return 0
    }, [])

    const startDrag = useCallback(
        (e: MT) => {
            setPressed(true)
            setClientXStart(getClientX(e))
            setScrollLeft(e.currentTarget.scrollLeft)
        },
        [getClientX]
    )

    const moveDrag = useCallback(
        (e: MT) => {
            if (!pressed) return

            setIsScrolling(true)

            e.currentTarget.scrollLeft =
                scrollLeft + clientXStart - getClientX(e)
        },
        [pressed, clientXStart, getClientX, scrollLeft]
    )

    const stopDrag = useCallback((e: MT) => {
        setScrollLeft(e.currentTarget.scrollLeft)
        setIsScrolling(false)
        setPressed(false)
    }, [])

    return {
        draggers: { moveDrag, startDrag, stopDrag },
        isMoving: isScrolling,
        pressed,
    }
}

export default useTabs
